import { render } from "./AddChampsLibre.vue?vue&type=template&id=8f9c68f2&scoped=true&ts=true"
import script from "./AddChampsLibre.vue?vue&type=script&lang=ts"
export * from "./AddChampsLibre.vue?vue&type=script&lang=ts"

import "./AddChampsLibre.vue?vue&type=style&index=0&id=8f9c68f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f9c68f2"]])

export default __exports__